module.exports = __webpack_public_path__ + "static/media/paninoteca profilo.172506e8.svg";